import { useEffect } from 'react'
import { TutorialStep } from '../../tour/types'

export const useTourKeyboardControls = (
  run: boolean,
  isTourActive: boolean,
  stepIndex: number,
  setStepIndex: (index: number) => void,
  joyrideSteps: any[],
  originalTutorialSteps: readonly TutorialStep[]
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!run || !isTourActive) {
        return
      }

      const currentOriginalStep = originalTutorialSteps[stepIndex] as TutorialStep
      if (currentOriginalStep?.isWelcomeScreen) {
        return
      }

      // Allow typing in input fields, textareas, and contenteditable elements
      const target = event.target as HTMLElement
      if (
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.contentEditable === 'true' ||
          target.closest('[data-tour-element="true"]'))
      ) {
        return
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault()
        if (stepIndex < joyrideSteps.length - 1) {
          setStepIndex(stepIndex + 1)
        }
        return
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault()
        if (stepIndex > 0) {
          setStepIndex(stepIndex - 1)
        }
        return
      }

      event.preventDefault()
      event.stopPropagation()
    }

    window.addEventListener('keydown', handleKeyDown, true)
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [run, isTourActive, stepIndex, setStepIndex, joyrideSteps.length, originalTutorialSteps])
}
